<template>
  <div>
    <TopHeader />

    <section class="container-fluid uc-bg uc-userCenter">
      <div class="container">
        <section class="uc-userCenterPanel bg-white">
          <div class="face">
            <img
              :src="$store.getters.user.avatar"
              :alt="$store.getters.user.first_name"
              onerror="this.src=document.getElementById('avatar').src;this.onerror=null;"
            />
          </div>
          <div class="left">
            <h3>{{ $store.getters.user.first_name }}</h3>
            <p>{{ $store.getters.user.username }}</p>
          </div>
          <div class="info">
            <div class="icon-help">
              <div class="detail">
                <div class="detail-box">
                  <table style="width:100%;">
                    <tr>
                      <th style="width:10%;text-align:left;">序</th>
                      <th style="width:25%;text-align:left;">等级编号</th>
                      <th style="width:25%;text-align:left;">等级名称</th>

                      <th style="width:20%;text-align:left;">等级学分</th>
                      <th style="width:20%;text-align:left;">等级图标</th>
                    </tr>
                    <tr v-if="creditratings.length == 0">
                      <td colspan="10">
                        <div class="content-empty">
                          <div class="emptyimg-box"></div>
                          <p>暂无相关内容</p>
                        </div>
                      </td>
                    </tr>

                    <tr v-for="(item, index) in creditratings" :key="index">
                      <td>{{ item.row }}</td>
                      <td>{{ item.code }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.score }}</td>
                      <td>
                        <img
                          :src="item.icon"
                          :alt="item.name"
                          style="width:80px;"
                          v-if="item.icon"
                        />
                        <span v-else>--</span>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <img
              class="icon-credit"
              :src="studyscore.icon"
              :alt="studyscore.name"
              v-if="studyscore.icon"
            />
            <b v-else>{{ studyscore.name }}</b>
          </div>
          <div class="info">
            <div class="item">
              <h3>
                <i class="big">{{ model.finish_course }}</i>
                门
              </h3>
              <p>完成课程</p>
            </div>
            <img src="../../assets/images/icon-line.png" class="line" />
            <div class="item">
              <h3>
                <i class="big">{{ (model.study_hour / 60 / 60).toFixed(1) }}</i>
                h
              </h3>
              <p>总学时</p>
            </div>
            <img src="../../assets/images/icon-line.png" class="line" />
            <div class="item">
              <h3>
                <i class="big">{{ model.total_integral }}</i>
              </h3>
              <p>总积分</p>
            </div>
            <img src="../../assets/images/icon-line.png" class="line" />
            <div class="item">
              <h3>
                <i class="big">{{ studyscore.total_score }}</i>
              </h3>
              <p>总学分</p>
            </div>
          </div>
          <router-link :to="{ name: 'PersonalCenter' }" class="uc-btn btn-edit">
            <img src="../../assets/images/icon-edit.png" class="uc-icon28" />
          </router-link>
        </section>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-24 col-sm-6">
            <div class="g-sideMenu">
              <div class="title">个人中心</div>
              <div class="list">
                <div
                  v-for="(item, index) in leftMenuList"
                  :key="index"
                  class="item"
                  :class="{ on: path.indexOf(item.path) === 0 }"
                  @click="path = item.path"
                >
                  <router-link :to="item.path" v-html="item.name"></router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="col-24 col-sm-18 uc-pl20">
            <router-view />
          </div>
        </div>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'PersonalLayout',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      model: {},
      studyscore: {},
      leftMenuList: [
        { name: '培训档案', path: '/personal/study' },
        { name: '我的学分', path: '/personal/mystudyscore' },
        { name: '我的积分', path: '/personal/integral' },
        { name: '我的证书', path: '/personal/certificate' },
        { name: '我的收藏', path: '/personal/favorites' },
        { name: '兑换记录', path: '/personal/order' },
        { name: '地址管理', path: '/personal/address' },
        { name: '我的话题', path: '/personal/mytopic' },
        { name: '我的笔记', path: '/personal/mynote' },
      ],
      path: this.$route.path.toLowerCase(),
      creditratings: [],
    };
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.path = to.path.toLowerCase();
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.getLearningStatistics();
      this.getMyStudyScore();
      this.getCreditRatings();
    },
    async getLearningStatistics() {
      const response = await this.$api.user.getLearningStatistics();
      const data = response.data.data;
      this.model = data;
      this.$store.dispatch('setLearningStatistics', data);
    },
    // 我的学分
    async getMyStudyScore() {
      const response = await this.$api.course.getMyStudyScore();
      this.studyscore = response.data.data || {};
    },
    // 我的学分
    async getCreditRatings() {
      const response = await this.$api.course.getCreditRatings();
      this.creditratings = response.data.data || {};
    },
  },
};
</script>
